var exports = {
  "az": "Box__9aTioE",
  "ue": "shared__KSUE2D",
  "mr": "highlighted__0kA4Kf",
  "eR": "major__A5_AyP",
  "NX": "viewerDidAuthor___hTwPO",
  "Ay": "default__YwZYbp",
};

module.exports = exports;
